import { render, staticRenderFns } from "./about_page_configuration.vue?vue&type=template&id=329dac9e&"
import script from "./about_page_configuration.vue?vue&type=script&lang=js&"
export * from "./about_page_configuration.vue?vue&type=script&lang=js&"
import style0 from "./about_page_configuration.vue?vue&type=style&index=0&id=329dac9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports